import { Control } from "react-hook-form";
import { InventoryProductSpecificationValues } from "../inventory-product-specification-form.component";
import Grid from "@mui/material/Grid";
import InputFormField from "components/input-form-field";

export type OtherSpecificationValues = {
  additional_notes: string;
};

export const EMPTY_OTHER_SPECIFICATION: OtherSpecificationValues = {
  additional_notes: "",
};

type OtherSpecificationFormProps = {
  control: Control<InventoryProductSpecificationValues, object>;
};

export default function OtherSpecificationForm({
  control,
}: OtherSpecificationFormProps) {
  return (
    <Grid
      container
      width="100%"
      sx={{ pb: 4 }}
      columnSpacing={2}
      rowSpacing={4}
    >
      <Grid item xs={12}>
        <InputFormField
          name="other.additional_notes"
          label="Additional notes"
          control={control}
          sx={{ ml: 0 }}
          multiline
        />
      </Grid>
    </Grid>
  );
}
